import { getErrorReason, tableNotFoundError, suppressableOperations } from './getErrorReason';

export const shouldSuppressSnackbar = ({ operationName }, response) =>
  suppressableOperations.includes(operationName) && getErrorReason(response?.errors) === tableNotFoundError;
